module.exports = __webpack_public_path__ + "static/media/access.fe463487.svg";